// extracted by css-extract-rspack-plugin
export default {"errorBox":"IO2jc"};